<template>
  <div>
    
    <div>
      <vue-headful 
      title="imgsurv" 
      description="Looking for free image share sites? Imgsurv is a free and anonymous temporary image hosting service. Start your private image hosting without an account!" 
      url="https://www.imgsurv.com/home" />
    </div>

    <div style="height:90vh;" xs12>
      <div style="height:7vw;" xs12/>
      <v-flex xs12 md10 offset-md1 lg8 offset-lg2>
      <carousel :loop="true" :per-page="1" :mouse-drag="true" :speed="425" paginationActiveColor="gray">
        <slide>
          <v-jumbotron class="pb-5" :src="require('../assets/14.jpeg')">
            <v-container fill-height>
              <v-layout align-center>
                <v-flex>
                  <h3 class="display-3 white--text">imgsurv</h3>
  
                  <v-divider class="my-3"></v-divider>
  
                  <span class="subheading white--text">The internets easiest way to share photos!</span>
                  <br/>
                  <span class="subheading white--text">Seriously...you don't even have to sign up</span>
                  <br/>
  
                </v-flex>
              </v-layout>
            </v-container>
          </v-jumbotron>
        </slide>
        <!-- <slide>
              <v-jumbotron class="pb-5">
                <v-container fill-height>
                  <v-layout align-center>
                    <v-flex>
                      <h3 class="display-3">No more missed moments</h3>
        
                      <v-divider class="my-3"></v-divider>
        
                      <span class="subheading">Just generate a Surv</span>
                      <br/>
                      <span class="subheading">Share the link</span>
                      <br/>
                      <span class="subheading">Go party!</span>
                      <br/>
                      <span class="subheading">Anyone with the link can download or upload photos to the Surv</span>
        
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-jumbotron>
            </slide> -->
        <slide>
          <v-jumbotron class="pb-5" :src="require('../assets/10.jpeg')">
            <v-container fill-height>
              <v-layout align-center>
                <v-flex>
                  <h3 class="display-3 white--text">Holding an event?</h3>
  
                  <v-divider class="my-3"></v-divider>
  
                  <span class="subheading white--text">Create a Surv for the event and share the link with your family and friends</span>
                  <br/>
                  <span class="subheading white--text">They just follow your link and start uploading!</span>
                  <br/>
                  <span class="subheading white--text">We don't downsize your photos like email, text or social media</span>
                  <br/>
  
                </v-flex>
              </v-layout>
            </v-container>
          </v-jumbotron>
        </slide>
        <slide>
          <v-jumbotron class="pb-5" :src="require('../assets/15.jpeg')">
            <v-container fill-height>
              <v-layout align-center>
                <v-flex>
                  <h3 class="display-3 white--text">No need to cleanup</h3>
  
                  <v-divider class="my-3"></v-divider>
  
                  <span class="subheading white--text">All Survs last 24 hours</span>
                  <br/>
                  <span class="subheading white--text">After that time is up, your Surv will delete itself, so your photos aren't just floating around the internet</span>
  
                </v-flex>
              </v-layout>
            </v-container>
          </v-jumbotron>
        </slide>
      </carousel>
      </v-flex>

      <div style="height:5vh;" xs12/>
      <!-- scrollspy activator button -->
      <ul v-scroll-spy-active v-scroll-spy-link>
        <li>
          <a style="color: inherit;">
            <v-btn icon>
              <img class="btn-imag" src="../assets/if_button-power.png" />
            </v-btn>
          </a>
        </li>
      </ul>
      <div style="height:1vh;" xs12/> Get Started

    </div>
  
    <div v-scroll-spy="{time: 350, steps: 150}">
      <div style="height:100vh;" xs12>
        <div style="height:23vw;" xs12/>
        <v-container grid-list-md text-xs-center>
          <v-layout row wrap>
            <v-flex xs12 sm3 offset-sm2 md3 offset-md2 lg3 offset-lg2>
              <!-- <v-flex xs12> -->
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
  
                    <v-btn icon :disabled="generateBtnClicked" v-on:click="generateServer()">
                      <img class="btn-imag" src="../assets/i-up.png" />
                    </v-btn>
                    <br/>
                    <br/>
                    <span class="headline">Generate a Surv</span>
                    <br/>
  
  
  
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
  
            <v-flex style="padding-top:5vh; height:10vh;" sm2 md2 lg2>
              or...
            </v-flex>
  
            <v-flex xs12 sm4 md5 lg3>
              <div height="30vh">
                <v-container fill-height fluid>
                  <v-layout fill-height>
  
                    <v-flex xs12 align-end flexbox>
                      <v-btn icon @click="goToSurv()">
                        <img class="btn-imag" src="../assets/i-right.png">
                      </v-btn>
                      <br/>
                      <br/>
                      <span class="headline">Join a Surv</span>
  
                      <div class="text-xs-center">
                        <v-text-field v-on:keyup.enter="goToSurv()" v-model="joinServerNameTextField" placeholder="  Enter the Surv Code..." single outline clearable color="black"></v-text-field>
                      </div>
  
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
            </v-flex>
  
          </v-layout>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import shortid from "shortid";
  import config from "../config";
  import hri from "human-readable-ids";
  import Chitika from "./ads/Chitika";
  
  export default {
    name: "MainMenu",
    components: {
      Chitika
    },
    data() {
      return {
        joinServerNameTextField: "",
        generateBtnClicked: false
      };
    },
  
    methods: {
      goToSurv: function() {
        this.$router.push({
          name: 'ServerRoom',
          params: {
            id: this.joinServerNameTextField.toLowerCase()
          }
        })
      },
  
      generateServer: function() {
        //some absolute trash implementation of generating an id
        let h = hri.hri.random();
        h = h.split("-");
        h.pop(); //remove the last index because it is just a number 1-100 which is too weak for me
  
        let indx = Math.floor(Math.random() * 3) + 0; //get a random index from 0-2 to identify which array index to remove from 'h'
  
        let serverId = shortid
          .generate()
          .toLowerCase()
          .replace(/\W/g, "")
          .replace("_","")//random alphanumeric short id
          
        serverId = serverId.substring(0, 3); //get only the first 3 values
  
        //randomly remove a char from the serverId
        var removeChar = Math.floor(Math.random() * 3) + 0;
        if (removeChar < h.length) {
          serverId =
            serverId.substr(0, removeChar) + serverId.substr(removeChar + 1);
        }
  
        h.splice(indx, 0, serverId); //insert the random serverId into the 'h' array
  
        //concat the Id to '-' separated string
        var theId = "";
        for (let i = 0; i < h.length; i++) {
          theId += h[i];
          if (i != h.length - 1) {
            theId += "-";
          }
        }
  
        let payload = {
          serverName: theId
        };
        let endpoint = config.AWS_LAMBDA_GENERATE_SERVER_ENDPOINT;
  
        this.generateBtnClicked = true;
  
        axios
          .post(endpoint, payload)
          .then(res => {
            if (res.status == 200 && res.data) {
              //window.location.href = `s/${res.data}`;
              this.$router.push({
                name: 'ServerRoom',
                params: {
                  id: res.data
                }
              })
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  };
</script>

<style scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/MainMenu.vue